// eslint-disable-next-line no-unused-vars
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  LINK_REPORT_DASHBOARD,
  LABEL_REPORT_DASHBOARD,
  LINK_CONSENT_REPORT_DASHBOARD,
  LABEL_CONSENT_REPORT_DASHBOARD,
  LABEL_IGA_REPORT_DASHBOARD,
  LINK_IGA_REPORT_DASHBOARD,
} from '../utils/config'
import UsersSvg from '../assets/User-icon.svg'
import GroupsSvg from '../assets/Community-icon.svg'
import ApplicationsSvg from '../assets/Reports-icon.svg'
import AuditsSvg from '../assets/Audits-icon.svg'

const MenuItems = () => {
  const { t } = useTranslation()

  const USERS = {
    id: 'users',
    name: t('users.name'),
    text: t('users.text'),
    list: [
      t('users.list.View-and-edit'),
      t('users.list.Create-bulk-users'),
      t('users.list.Re-activate-bulk-users'),
    ],
    links: [
      {
        label: t('users.links.Create-new-user'),
        path: '/create-user',
        btnClassName: 'primary-btn',
      },
      {
        label: t('users.links.view-edit'),
        path: '/search-user',
        btnClassName: 'secondary-btn',
      },
    ],
    svg: UsersSvg,
  }

  const GROUPS = {
    id: 'groups',
    name: t('groups.name'),
    text: t('groups.text'),
    list: [t('groups.list.View-and-edit')],
    links: [
      {
        label: t('groups.links.Create-new-user'),
        path: '/create-group',
        btnClassName: 'primary-btn',
      },
      {
        label: t('groups.links.view-edit'),
        path: '/search-group',
        btnClassName: 'secondary-btn',
      },
    ],
    svg: GroupsSvg,
  }

  const AUDITS = {
    id: 'audits',
    name: t('audits.name'),
    text: t('audits.text'),
    list: [t('audits.list.Check-status')],
    links: [
      {
        label: t('audits.links.user-activity'),
        path: '/user-activities',
        btnClassName: 'primary-btn',
      },
      {
        label: t('audits.links.view-edit'),
        path: '/bulk-users-activity',
        btnClassName: 'secondary-btn',
      },
    ],
    svg: AuditsSvg,
  }

  const REPORTS = {
    id: 'reports',
    name: t('reports.name'),
    text: t('reports.text'),
    list: [t('reports.list.breakdown'), t('reports.list.recent-reports')],
    links: [
      {
        label: t('reports.links.view-reports'),
        options: [
          {
            value: LINK_REPORT_DASHBOARD,
            label: t(LABEL_REPORT_DASHBOARD),
          },
          {
            value: LINK_CONSENT_REPORT_DASHBOARD,
            label: t(LABEL_CONSENT_REPORT_DASHBOARD),
          },
          {
            value: LINK_IGA_REPORT_DASHBOARD,
            label: t(LABEL_IGA_REPORT_DASHBOARD),
          },
        ],
        btnClassName: 'primary-btn',
        shouldOpenInNewTab: true,
        isDropdown: true,
        dropdownLabel: t('reports.list.dropdown-label'),
      },
    ],
    svg: ApplicationsSvg,
  }

  return [USERS, GROUPS, AUDITS, REPORTS]
}

export default MenuItems
